import { ReactTFC } from "../../../utils/fp/missing-ts-parts";

import { css } from "@emotion/react";

import { CSS_MQ } from "../../../styles/breakpoints";
import { FooterNavigationPrimary, FooterNavigationSecondary } from "./FooterNavigation";
import { FooterSocial } from "./FooterSocial";
import { FooterNewsletter } from "./FooterNewsletter";
import { FooterTernaryNavigation } from "./FooterTernaryNavigation";
import { PaymentMethods } from "./PaymentMethods";
import React from "react";
import { FooterData } from "@swo/storefront";

export const FooterTop: ReactTFC<FooterData> = props => {
  return (
    <div css={wrapperStyles}>
      <div
        css={css`
          grid-area: second;
          ${CSS_MQ.atLeastMd} {
            grid-area: top-left-first;
          }

          display: flex;
          flex-direction: column;
          justify-content: flex-start;
        `}
      >
        <FooterNavigationPrimary data={props.navigation.internal.primary} />
      </div>

      <div
        css={css`
          grid-area: third;
          ${CSS_MQ.atLeastMd} {
            grid-area: top-left-second;
          }
        `}
      >
        <FooterNavigationSecondary
          data={props.navigation.internal.secondary}
          cookieSettingsLabel={props.cookieSettingsLabel.value}
        />
      </div>

      <div
        css={css`
          grid-area: sixth;
          ${CSS_MQ.atLeastMd} {
            grid-area: bottom-left;
          }
        `}
      >
        <FooterSocial data={props.social} />
      </div>

      <div
        css={css`
          grid-area: first;
          ${CSS_MQ.atLeastMd} {
            grid-area: top-right-first;
          }
        `}
      >
        <FooterNewsletter {...props.newsletter} />
      </div>

      <div
        css={css`
          grid-area: fifth;
          margin-top: 20px;

          ${CSS_MQ.atLeastMd} {
            margin-top: 0;

            grid-area: top-right-second;
          }
        `}
      >
        <FooterTernaryNavigation data={props.navigation.external} />
      </div>
      <div
        css={css`
          grid-area: forth;
          ${CSS_MQ.atLeastMd} {
            grid-area: bottom-right;
            display: flex;
          }
        `}
      >
        <PaymentMethods data={props.paymentMethods} />
      </div>
    </div>
  );
};

const wrapperStyles = css`
  max-width: var(--max-content-width-new);
  width: 100%;

  display: grid;

  margin-left: auto;
  margin-right: auto;

  grid-template-columns: 100%;
  grid-template-rows: auto auto auto auto auto auto;
  grid-template-areas:
    "first"
    "second"
    "third"
    "forth"
    "fifth"
    "sixth";

  padding: 40px 0 20px 0;

  ${CSS_MQ.atLeastMd} {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    grid-template-rows: auto auto 105px;

    grid-template-areas:
      "top-left-first top-right-first"
      "top-left-second top-right-second"
      "bottom-left bottom-right";

    padding: 70px 0 30px 0;
  }
`;
